
export const state = {
	alert: { title: '消息', variant: 'info', show: false },
	page: { title: '订单系统' },
	navbar: { collapse: true },
	role: {name: 'guest'},
	tab: {index: 1},
	refresh: {reload: false},
	qyh: {},
	logoPath: '/static/img/logo2.png'
}

export const getters = {
	getAlert: state => state.alert,
	getPage: state => state.page,
	getNavbar: state => state.navbar,
	getRole: state => state.role.name,
	getTab: state => state.tab,
	getQyh: state => state.qyh,
	getLogoPath: state => state.logoPath
}

// actions
export const actions = {
	setInfo ({ commit, state }, msg) {
		Object.assign(msg, { variant: 'info', show: false })
		commit('ALERT_SET', { msg })
	},
	setSuccess ({ commit, state }, msg) {
		Object.assign(msg, { variant: 'success', show: false })
		commit('ALERT_SET', { msg })
	},
	setWarning ({ commit, state }, msg) {
		Object.assign(msg, { variant: 'warning', show: false })
		commit('ALERT_SET', { msg })
	},
	setError ({ commit, state }, msg) {
		Object.assign(msg, { variant: 'danger', show: false })
		commit('ALERT_SET', { msg })
	},
	hideAlert ({ commit, state }, msg) {
		Object.assign(msg, { variant: 'danger', show: false })
		commit('ALERT_SET', { msg })
	},
	setPage ({ commit, state }, msg) {
		commit('PAGE_SET', { msg })
	},
	setNavbar ({ commit, state }, msg) {
		commit('NAVBAR_SET', { msg })
	},
	setLoading ({ commit, state }, msg) {
		commit('updateLoadingStatus', {isLoading: msg})
	},
	setRole ({ commit, state }, msg) {
		commit('ROLE_SET', { msg })
	},
	setTab ({ commit, state }, msg) {
		commit('TAB_SET', { msg })
	},
	setQyh ({ commit, state }, msg) {
		commit('QYH_SET', { msg })
	}
}

export const mutations = {
	SET_LOGO_PATH (state, name) {
		let path = '/static/img/logo2.png'
		switch (name) {
			case 'yxg':
				path = '/static/img/logo_yxg.png'
			break
			case 'zytg':
				path = '/static/img/logo2.png'
			break
		}
		state.logoPath = path
	},
	ALERT_SET (state, { msg }) {
		// console.log('ALERT_SET: ', msg)
		state.alert.title = msg.title
		state.alert.variant = msg.variant
		state.alert.show = !!msg.title
	},
	PAGE_SET (state, { msg }) {
		Object.assign(state.page, msg)
	},
	NAVBAR_SET (state, { msg }) {
		Object.assign(state.navbar, msg)
	},
	ROLE_SET (state, { msg }) {
		Object.assign(state.role, {'name': msg})
	},
	TAB_SET (state, { msg }) {
		Object.assign(state.tab, {'index': msg})
	},
	QYH_SET (state, { msg }) {
		Object.assign(state.qyh, msg.qyh)
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/common.js